module.exports = __webpack_public_path__ + "static/media/20190402_071309.f41941bb.jpg";